
import { defineComponent } from 'vue'

interface ZCarouselT extends Vue {
  currentIndex: number
}

export default defineComponent({
  name: 'ZSlide',
  data() {
    return {
      index: 0
    }
  },
  computed: {
    visible(): boolean {
      return this.index === (this.$parent as ZCarouselT).currentIndex
    }
  }
})
